import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AuthServiceApi } from "../../services";

const initialState = {
  isAuthenticated: false,
  user: null,
  authToken: null,
  loading: false,
  error: '',
};

export const generateToken = createAsyncThunk('auth/generateToken', async (req) => {
    return await AuthServiceApi.generateToken(req).then(response => {
      return response?.data;
    });
});

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(generateToken.pending, state => {
      state.loading = true;
    });

    builder.addCase(generateToken.fulfilled, (state, action) => {
      console.log("redux auth res", action.payload);
      if (action?.payload?.error) {
        state.loading = false;
        state.authToken = "";
        state.isAuthenticated = false;
        state.error = '';
      } else {
        state.loading = false;
        state.authToken = action?.payload?.data.authToken;
        localStorage.setItem('authToken', action?.payload?.data.authToken);
        state.isAuthenticated = true;
        state.error = '';
      }
    });

    builder.addCase(generateToken.rejected, (state, action) => {
      state.loading = false;
      state.authToken = "";
      state.error = action.error.message;
    });
  }
});

export const { setUser } = authSlice.actions;
export default authSlice.reducer;